import { create } from 'zustand'

type UseComponentRenderingStoreType = {
  components: {
    [name: string]: boolean
  }
  // initialComponentsLoaded: {
  //   [name: string]: boolean
  // }
  hasComponentsLoaded: boolean
  addTrackingComponent: (name: string, hasLoaded: boolean) => void
  removeComponentTracking: (name: string) => void
  clearComponentsTracking: () => void
}

function hasAllComponentsRendered(components: { [name: string]: boolean }) {
  for (const value of Object.values(components)) {
    if (!value) {
      return false // Found a false value, return false
    }
  }
  return true // All entries are true, return true
}

const useComponentPerfRenderingStore = create<UseComponentRenderingStoreType>(
  (set) => ({
    components: {},
    // initialComponentsLoaded: {},
    hasComponentsLoaded: false,

    addTrackingComponent: (name, hasLoaded) =>
      set((state) => {
        if (state.components[name]) {
          return state
        }
        // state.initialComponentsLoaded[name] = hasLoaded

        state.components[name] = hasLoaded

        const hasComponentsLoaded = hasAllComponentsRendered(state.components)

        return { hasComponentsLoaded }
      }),

    removeComponentTracking: (name) =>
      set((state) => {
        delete state.components[name]
        // delete state.initialComponentsLoaded[name]
        return state
      }),

    clearComponentsTracking: () =>
      set({
        components: {},
        // initialComponentsLoaded: {},
        hasComponentsLoaded: false,
      }),
  })
)

export default useComponentPerfRenderingStore
